<app-loader [isLoading]="isLoading"></app-loader>

<div class="content">
  <app-restaurant-filter-bar [config]="filterBarConfig" [selectedFilter]="selectedFilter" [searchText]="searchText"
    [startDate]="startDate" [endDate]="endDate" (searchChange)="onSearchChange($event)"
    (filterChange)="onFilterChange($event)" (dateRangeChange)="onDateRangeChange($event)"
    (exportClick)="onExportClick()"></app-restaurant-filter-bar>

  <div style="padding-left: 40px; margin-bottom: 16px;">
    <app-export-excel-button text="Exportar Excel" (exportClick)="onExportClick()">
    </app-export-excel-button>
    <div class="switch" [class.active]="isActive" [class.inactive]="!isActive">
      <span>Mostrar solo usuarios con consumos</span>
      <mat-slide-toggle [checked]="isActive" (change)="onToggleChange($event.checked)"></mat-slide-toggle>
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
    class="mat-elevation-z8" id="restaurant-table">
    <!-- Columna de Usuarios -->
    <ng-container matColumnDef="users">
      <th mat-header-cell *matHeaderCellDef>USUARIO</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">
          @if(qeqDataLoaded){
          {{ element.employee_name | qeqPipe }}
          }@else{
          {{ element.employee_name || "Cargando..." }}
          }
        </span>
      </td>
    </ng-container>

    <!-- Columna de Id Usuario -->
    <ng-container matColumnDef="id-users">
      <th mat-header-cell *matHeaderCellDef>ID EMPLEADO</th>
      <td mat-cell *matCellDef="let element">
        <span style="font-size: 16px">{{ element.employee_id }}</span>
      </td>
    </ng-container>

    <!-- Columna de Desayunos Completados -->
    <ng-container matColumnDef="breakfast-completed">
      <th mat-header-cell *matHeaderCellDef>DESAYUNOS</th>
      <td mat-cell *matCellDef="let element">
        <span class="utility-button">
          {{ element.breakfast_spent }}€ / ({{ element.breakfast_completed }})
        </span>
      </td>
    </ng-container>

    <!-- Columna de Comidas Completadas -->
    <ng-container matColumnDef="lunch-completed">
      <th mat-header-cell *matHeaderCellDef>COMIDAS</th>
      <td mat-cell *matCellDef="let element">
        <span class="utility-button">
          {{ element.lunch_spent }}€ / ({{ element.lunch_completed }})
        </span>
      </td>
    </ng-container>

    <!-- Columna de Total Gastado -->
    <ng-container matColumnDef="total-spent">
      <th mat-header-cell *matHeaderCellDef>TOTAL</th>
      <td mat-cell *matCellDef="let element">
        <span class="utility-button">{{ element.total_spent }}€</span>
      </td>
    </ng-container>

    <!-- Columna de Total Gastado -->
    <ng-container matColumnDef="total-company-spent">
      <th mat-header-cell *matHeaderCellDef>TOTAL EMPRESA</th>
      <td mat-cell *matCellDef="let element">
        <span class="utility-button">{{ element.total_company_spent }}€</span>
      </td>
    </ng-container>

    <!-- Columna de Total No Cargado -->
    <ng-container matColumnDef="total-no-charged">
      <th mat-header-cell *matHeaderCellDef>TOTAL NO CARGADO</th>
      <td mat-cell *matCellDef="let element">
        <span class="utility-button">{{ element.total_no_charged }}</span>
      </td>
    </ng-container>

    <!-- <ng-container matColumnDef="charge">
      <th mat-header-cell *matHeaderCellDef>COBRO</th>
      <td mat-cell *matCellDef="let element">
        <mat-slide-toggle></mat-slide-toggle>
      </td>
    </ng-container> -->

    <!-- Columna de Acciones -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button class="acciones" (click)="seePunches(element)">
          <mat-icon class="primary-icon">visibility</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>